function urlsafeEncode64(string) {
  return window
    .btoa(string)
    .replace(/[+/=]/g, (match) => ({ '+': '-', '/': '_', '=': '' })[match]);
}

export { urlsafeEncode64 };
